import { render, staticRenderFns } from "./BaseInputRange.vue?vue&type=template&id=3bbc64b6&"
import script from "./BaseInputRange.vue?vue&type=script&lang=js&"
export * from "./BaseInputRange.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRange.vue?vue&type=style&index=0&id=3bbc64b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports